// frontend/src/services/api.js
import api from '../api/axios';

// `api` already sets baseURL to `REACT_APP_API_URL` and attaches Authorization header.
// CMS endpoints live under /api/cms on the backend, so prefix with `/cms` here.
const CMS = '/cms';

// Define API functions for each manager
export const heroSliderAPI = {
    getAll: () => api.get(`${CMS}/hero-sliders`),
    create: (data) => api.post(`${CMS}/hero-sliders`, data),
    update: (id, data) => api.put(`${CMS}/hero-sliders/${id}`, data),
    delete: (id) => api.delete(`${CMS}/hero-sliders/${id}`),
};

export const portalAPI = {
    getAll: () => api.get(`${CMS}/portals`),
    create: (data) => api.post(`${CMS}/portals`, data),
    update: (id, data) => api.put(`${CMS}/portals/${id}`, data),
    delete: (id) => api.delete(`${CMS}/portals/${id}`),
};

export const aboutAPI = {
    get: () => api.get(`${CMS}/about`),
    update: (data) => api.post(`${CMS}/about`, data), // Uses POST for simplicity
};

export const teamAPI = {
    getAll: () => api.get(`${CMS}/team`),
    create: (data) => api.post(`${CMS}/team`, data),
    update: (id, data) => api.put(`${CMS}/team/${id}`, data),
    delete: (id) => api.delete(`${CMS}/team/${id}`),
};

export const departmentAPI = {
    getAll: () => api.get(`${CMS}/departments`),
    create: (data) => api.post(`${CMS}/departments`, data),
    update: (id, data) => api.put(`${CMS}/departments/${id}`, data),
    delete: (id) => api.delete(`${CMS}/departments/${id}`),
};

export const footerAPI = {
    get: () => api.get(`${CMS}/footer`),
    update: (data) => api.post(`${CMS}/footer`, data),
};

// You'll also need an authAPI for the AdminManager
export const authAPI = {
    getAdmins: () => api.get('/hrms/admins'),
    // ... register, delete admin
};

// Filter options API for MindMap dropdowns
export const filterAPI = {
    getCountries: () => api.get('/filters/countries'),
    getLanguages: () => api.get('/filters/languages'),
    getCategories: () => api.get('/filters/categories'),
};